import type { NavigateFunction } from 'react-router-dom';
import { jumpTo } from '@/utils/jumpTo';

export const useNavigation = (function () {
  let navigateRef: NavigateFunction = null;

  function setNavigate(navigate: NavigateFunction) {
    navigateRef = navigate;
  }

  function navigate(path: string) {
    if (navigateRef) {
      navigateRef(path);
      return;
    }
    jumpTo(path);
  }

  return function () {
    return {
      navigate,
      setNavigate,
    };
  };
})();
